import { Bombs } from './Bombs.js';
import { FONT, larger, light_smaller } from './Design.js';
import { Level } from './Level.js';
import { Player } from './Player.js';
import { Stars } from './Stars.js';
import { 
	GAME_VERSION,
	isDebugging,
	singleplayer_Highscore,
	singleplayer_SaveScore
} from './State.js';

// https://rexrainbow.github.io/phaser3-rex-notes/docs/site/touchevents/#multi-touch

export class SinglePlayerScene extends Phaser.Scene {

    constructor ()
    {
        super({ key: 'SinglePlayerScene', active: false });

		this.score = 0;
		this.gameOver = false;
    }

	init(data) {
		this.skinTone=data.skinTone||0;
	}

    create ()
    {
        
		//  A simple background for our game
		this.add.image(400, 300, 'sky');

		//  Here we create the ground.
		let erdboden = this.physics.add.staticGroup();
		//  Scale it to fit the width of the game (the original sprite is 400x32 in size)
		erdboden.create(400, 568, 'ground').setScale(2).refreshBody();

		this.erdboden = erdboden;

		this.level = new Level(this.physics);

		this.player = new Player('singleplayer',this.skinTone, this.physics, this.anims)

		//  Input Events
		let cursors = this.input.keyboard.createCursorKeys();
		this.cursors = cursors

		/*
		this.input.on('pointerdown', function(pointer){

			var touchX = pointer.x;
			if (touchX < game.canvas.width / 4) {
				cursors.left.isDown = true;
			} else if (touchX > game.canvas.width * 3 / 4) {
				cursors.right.isDown = true;
			} else {
				cursors.up.isDown = true;
			}
		});
		*/
		
		if (isDebugging()) {
			this.input.keyboard.on('keydown-P', () => {this.createBomb()});
		}
		this.input.keyboard.on('keydown-SPACE', function(pointer){
			cursors.up.isDown = true;
		});
		this.input.keyboard.on('keyup-SPACE', function(pointer){
			cursors.up.isDown = false;
		});
		this.input.on('pointerup', function(pointer){
			cursors.left.isDown = false;
			cursors.right.isDown = false;
			cursors.up.isDown = false;
		});

		this.stars = new Stars(this.physics, 12);

		this.bombs = new Bombs(this.physics);

		//  The score
		let scoreText = this.add.text(16, 16, 'Punkte: 0', larger);
		this.scoreText = scoreText;
		let levelText = this.add.text(16, 70, 'Level: ' + this.level.nr(), FONT);
		this.levelText = levelText;
		if (singleplayer_Highscore())
			this.add.text(16, 52, 'Highscore: ' + singleplayer_Highscore().score, FONT);

		this.add.text(750,580, 'v.'+GAME_VERSION, light_smaller)

		this.level.addCollider(this.player.img());
		this.level.addCollider(this.stars.img());
		this.level.addCollider(this.bombs.grp());
		this.physics.add.collider(this.player.img(), erdboden);
		this.physics.add.collider(this.stars.img(), erdboden);
		this.physics.add.collider(this.bombs.grp(), erdboden);

		//  Checks to see if the player overlaps with any of the stars, if he does call the collectStar function
		this.physics.add.overlap(this.player.img(), this.stars.img(), this.collectStar, null, this);

		this.physics.add.collider(this.player.img(), this.bombs.grp(), this.hitBomb, null, this);
	}

	update ()
	{
		if (this.gameOver)
		{
			return;
		}

		this.player.update(this.cursors)
	}

	collectStar (pl, star)
	{
		let stars = this.stars;
		let levelText = this.levelText;

		star.disableBody(true, true);

		//  Add and update the score
		this.score += 10;
		this.scoreText.setText('Punkte: ' + this.score);

		if (stars.areAllCollected())
		{
			stars.newBatchOfStarsToCollect();

			this.createBomb(pl.x)

			this.level.up()
		}
		levelText.setText('Level: ' + this.level.nr());
	}
	
	createBomb(playerx=0) {
		if (playerx < 400)
			this.bombs.createOnRightScreen()
		else
			this.bombs.createOnLeftScreen()
	}

	hitBomb (p, bomb)
	{
		this.physics.pause();

		this.player.hitBomb()

		this.gameOver = true;

		singleplayer_SaveScore(this.score, this.player.skinTone);
		
		this.add.image(this.game.canvas.width/2-40, this.game.canvas.height/2,'gameover');

        this.game.destroy(false);

	}
}